// extracted by mini-css-extract-plugin
export default {"menuContainer":"MenuPopup_menuContainer__f2nwZ","closeBtn":"MenuPopup_closeBtn__9GxY0","logo":"MenuPopup_logo__uGh1l","menu":"MenuPopup_menu__WxxuY"};